<template>
  <div v-if="loading" style="text-align: center; padding: 40px">
    <van-loading size="30px" type="spinner" vertical>加载中..</van-loading>
  </div>
  <div v-if="step == 1 && !loading" class="register">
    <h2>{{ tenant.TenantName }} • 渠道申请</h2>
    <van-form @failed="onFailed" @submit="onSubmit">
      <van-cell-group inset>
        <van-field
          v-model="form.userName"
          label="姓名"
          name="userName"
          placeholder="请输入姓名"
          required
          :rules="[{ required: true, message: '请输入姓名' }]"
          size="large"
        />
        <van-field
          v-model.trim="form.wechat"
          label="微信号"
          label-width="100"
          name="wechat"
          placeholder="请输入微信号"
          required
          :rules="[{ required: true, message: '请输入微信号' }]"
          size="large"
        />
        <van-field
          v-model="form.phone"
          label="手机号码"
          name="phone"
          placeholder="请输入手机号码"
          required
          :rules="[
            { required: true, message: '请输入手机号码' },
            { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号码' },
          ]"
          size="large"
          type="tel"
        />
        <!-- <send-msm
          v-model="form.code"
          name="code"
          :phone="form.phone"
          :rules="[{ required: true, message: '请输入验证码' }]"
          size="large"
        /> -->
        <van-cell
          class="input-item"
          is-link
          size="large"
          title="生日"
          @click="showCalendar = true"
        >
          <template #value>
            <span v-if="!form.birthday" class="none">请选择</span>
            <span v-else>{{ formatDate(form.birthday) }}</span>
          </template>
        </van-cell>
        <van-action-sheet v-model:show="showCalendar">
          <van-datetime-picker
            v-model="date"
            :max-date="maxDate"
            :min-date="minDate"
            title="选择日期"
            type="date"
            @cancel="showCalendar = false"
            @confirm="onConfirm"
          />
        </van-action-sheet>
        <van-field
          v-model="form.address"
          label="地址"
          name="address"
          placeholder="请输入您的地址"
          size="large"
          type="textarea"
        />
      </van-cell-group>
      <div class="tips">
        加
        <span>*</span>
        为必填项
      </div>
      <div style="margin: 16px">
        <van-button
          block
          :loading="submitLoading"
          native-type="submit"
          type="primary"
        >
          提交
        </van-button>
      </div>
    </van-form>
  </div>
  <div v-if="step == 2" class="success">
    <p><van-icon color="#239561" name="success" size="60" /></p>
    <h2>您已完成{{ tenant.TenantName }}渠道申请！</h2>
    <!-- <h4>您的驾驶舱地址为：</h4>
    <h4>http://{{ form.tenantCode }}.tengyucloud.com (用电脑打开)</h4>
    <h4>
      <van-button type="primary" @click="copy">复制链接</van-button>
    </h4> -->
  </div>
</template>
<script>
  import store from '@/store'
  import { Toast, Dialog } from 'vant'
  import { wxShare } from '@/utils'
  import SendMsm from '@/components/SendMsm'
  export default {
    components: {
      // SendMsm,
    },
    data() {
      return {
        form: {
          userId: '',
          wechat: '',
          userName: '',
          phone: '',
          address: '',
          birthday: '',
          code: '',
          // tenantId: store.getters['user/getTenant'].TenantId,
        },
        showCalendar: false,
        minDate: new Date(1900, 0, 1),
        maxDate: new Date(),
        date: new Date(1990, 0, 1),
        tenant: {},
        loading: false,
        submitLoading: false,
        step: 1,
      }
    },
    created() {
      this.init()
    },
    methods: {
      async init() {
        const tenant = await store.getters['user/getTenant']
        wxShare(`${tenant.TenantName}`, '渠道申请')
        this.tenant = tenant
        this.loading = true
        await store.dispatch('user/getUserInfo').catch((e) => {
          this.loading = false
        })
        const userInfo = store.getters['user/getUserInfo']
        this.form.userId = userInfo.UserId
        if (userInfo.Account === userInfo.UserId) {
          // 说明用户还未进行设置accout 跳转至设置accout页面
          Dialog.alert({
            title: '温馨提示',
            confirmButtonText: '去注册',
            message: '您还未注册，将跳转至注册页面！',
          }).then(() => {
            this.$go('userRegister', {
              query: { redirect: this.$route.fullPath },
            })
            //router.back()
          })
        } else {
          // form.value.phone = userInfo.Phone
          // form.value.nickName = userInfo.NickName
          // form.value.userName = userInfo.UserName
        }

        this.getChannel()

        // const tenant = store.getters['user/getTenant']
        wxShare(`${tenant.TenantName}`, '渠道申请')

        this.loading = false
      },

      async getChannel() {
        const userInfo = store.getters['user/getUserInfo']
        const tenant = await store.getters['user/getTenant']
        store
          .dispatch('user/GetChannel', {
            channelId: userInfo.UserId,
            tenantId: tenant.TenantId,
          })
          .then((data) => {
            this.channel = data.Data
            const { Data } = data
            if (Data.MarketingChannelId) {
              Dialog.alert({
                title: '温馨提示',
                confirmButtonText: '去推广收益页面',
                message: '您已经申请过渠道了！',
              }).then(() => {
                this.$go('Channel', {}, 'replace')
              })
            }
          })
          .catch((e) => {
            console.log(e + '获取渠道信息失败')
          })
      },

      copy() {
        this.$copyText(`http://${this.form.tenantCode}.tengyucloud.com`).then(
          function (e) {
            Toast.success('复制成功')
          },
          function (e) {
            Toast.fail('复制失败，请手动复制')
          }
        )
      },
      onSubmit() {
        this.submitLoading = true
        // store
        //   .dispatch('user/VerificateCode', {
        //     phone: this.form.phone,
        //     code: this.form.code,
        //   })
        //   .then((data) => {
        this.save()
        // })
        // .catch((e) => {
        //   console.log(e)
        //   this.submitLoading = false
        //   Toast.fail('验证码错误', e)
        // })
      },
      async save() {
        const params = JSON.parse(JSON.stringify(this.form))
        const tenant = await store.getters['user/getTenant']
        params.tenantId = tenant.TenantId
        params.userName = params.userName.trim()
        if (!params.userName) {
          Toast('姓名不能为空')
          this.submitLoading = false
          return
        }
        if (this.form.birthday) {
          params.birthday = this.formatDate(this.form.birthday)
        }
        store
          .dispatch('user/ChannelApply', params)
          .then((data) => {
            const { Data } = data
            // Toast.success('提交成功')
            this.submitLoading = false
            setTimeout(() => {
              this.step = 2
            }, 500)
          })
          .catch((e) => {
            this.submitLoading = false
            Toast.fail(e.Message || '提交失败')
          })
      },
      onFailed(val) {
        Toast.fail(val.Message || '提交失败')
        this.submitLoading = false
      },
      formatDate(date) {
        return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
      },
      // onConfirmTime(value) {
      //   this.showTime = false
      //   this.form.birthday = value
      // },
      onConfirm(value) {
        this.showCalendar = false
        this.form.birthday = value
      },
    },
  }
</script>
<style lang="scss" scoped>
  .register {
    h2 {
      text-align: center;
      font-size: 20px;
      font-weight: normal;
      color: #555;
    }
  }
  .no-border {
    .van-cell::after {
      border: none;
    }
  }
  .http {
    margin-top: -4px;
    padding: 0 0 10px 24px;
    color: #999;
    line-height: 24px;
    span {
      display: inline-block;
      min-width: 40px;
      &.line {
        color: #f00;
        border-bottom: 1px solid #999;
        text-align: center;
      }
    }
  }
  .tips {
    margin: 10px 16px;
    font-size: 14px;
    color: #999;
    span {
      color: #f00;
      font-size: 16px;
    }
  }
</style>
